module.exports = __webpack_public_path__ + "static/img/advantages-3.d053847b.png";